// extracted by mini-css-extract-plugin
module.exports = {"d1hy47nz":"d1hy47nz","mx029sy":"mx029sy"};